import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import TestCaseList from './testCaseSection/TestCaseList'
import TestRunReport from './reportSection/TestRunReport'
import BasicDetails from './basicDetails/BasicDetails'
import { message } from 'antd'
import { apiDownloadReport } from '../../../redux/testRun/testRun.service'
import ExportReportModal from './exportReport/ExportReportModal'
import styles from '../../../testrun.module.css'

const TestRunDetails = ({ reportId: reportIdProp, projectId }) => {
    const { id: routeId } = useParams()
    const id = reportIdProp || routeId

    const [exporting, setExporting] = useState(false)
    const [isOpen, setOpen] = useState(false)

    const handleExportImage = async (payload) => {
        try {
            setExporting(true)

            const downloadReportResp = await apiDownloadReport(payload)

            const { data } = downloadReportResp
            if (data.status !== 200)
                throw new Error(`Download failed (${data.status})`)

            const link = document.createElement('a')
            link.href = URL.createObjectURL(data?.data)
            link.download = payload?.reportName?.replace(/\s+/g, '_')
            link.click()
            URL.revokeObjectURL(link.href)

            setOpen(false)
        } catch (err) {
            message.error(err.message || 'Failed to export report')
        } finally {
            setExporting(false)
        }
    }

    return (
        <div className={styles.pageContainer}>
            <div className={styles.pageBlock}>
                <BasicDetails setOpen={setOpen} projectId={projectId} />
            </div>
            <div className={styles.pageBlock}>
                <TestRunReport reportId={id} />
            </div>
            <div className={styles.reportWrapper}>
                <TestCaseList reportId={id} projectId={projectId} />
            </div>
            <ExportReportModal
                isOpen={isOpen}
                setOpen={setOpen}
                onExport={handleExportImage}
                exporting={exporting}
                reportId={id}
            />
        </div>
    )
}

export default TestRunDetails
